import Accordion from "../../../shared/ui/Accordion/Accordion/Accordion";
import styles from './AccodionComponent.module.scss';
import { Text } from "../../../shared/ui/Text/Text";
import accordionData from "../lib/data";
import { Stack } from "../../../shared/ui/Stack/Stack";

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP);


const AccordionComponent = () => {
    useGSAP(() => {
        gsap.to(".title__accordion", { "--opacity": 1,
                                    "--x": "0px",
                                    y:-10,  
                                    duration: 1, 
    });
    }, [])

    return (
        <section> 
        <div  className={styles.container}>
            <Stack 
                justifyContent = 'justifyCenter'   
                >
                <Text type="h2" size='xl' className={`title__accordion ${styles.title}`}>
                    ИНДИВИДУАЛЬНЫЙ ПЛАН ЛЕЧЕНИЯ
                </Text>    
            </Stack>
            <Stack 
                justifyContent = 'justifySrart'
                className={styles.accodian}>
                <Accordion accordionData={accordionData}/>          
            </Stack>
            </div>
        </section>
    );
};

export default AccordionComponent;